var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdClogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2291 65C50.9023 65 65.2293 50.6731 65.2293 33C65.2293 15.3269 50.9023 1 33.2291 1C15.5558 1 1.22882 15.3269 1.22882 33C1.22882 50.6731 15.5558 65 33.2291 65Z",
    fill: "#E89005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9284 32.5765C32.9582 32.5765 32.9823 32.5524 32.9823 32.5226C32.9823 32.4929 32.9582 32.4688 32.9284 32.4688C32.8987 32.4688 32.8745 32.4929 32.8745 32.5226C32.8745 32.5524 32.8987 32.5765 32.9284 32.5765Z",
    stroke: "#C10000",
    strokeWidth: 3.64867,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3607 19.2319C31.7643 18.586 34.2963 18.5894 36.6983 19.2418C39.1002 19.8941 41.286 21.172 43.0327 22.9451C48.4926 28.396 48.6811 37.0616 43.4503 42.3014C41.7727 43.9564 39.6857 45.1362 37.4026 45.7199C35.1195 46.3037 32.7223 46.2706 30.4562 45.624",
    stroke: "#C10000",
    strokeWidth: 4.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8563 35.9583C37.1007 39.2404 32.8217 40.3719 29.3015 38.4861C25.7814 36.6003 24.3625 32.4112 26.1047 29.1335C27.8468 25.8558 32.1392 24.7154 35.6594 26.6012C36.4369 27.0175 37.1382 27.5626 37.7338 28.2131",
    stroke: "#C10000",
    strokeWidth: 2.55506,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9841 44.5538C47.3838 55.5901 32.9664 59.1058 21.7773 52.4157C10.5882 45.7256 6.86603 31.3533 13.4663 20.3169C20.0666 9.28058 34.484 5.76494 45.6731 12.4595C48.1509 13.9357 50.3401 15.8496 52.1342 18.1079",
    stroke: "#C10000",
    strokeWidth: 6.01815,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2291 65C50.9023 65 65.2293 50.6731 65.2293 33C65.2293 15.3269 50.9023 1 33.2291 1C15.5558 1 1.22882 15.3269 1.22882 33C1.22882 50.6731 15.5558 65 33.2291 65Z",
    stroke: "url(#paint0_linear_27_762)",
    strokeWidth: 0.546803,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_762",
    x1: 33.2291,
    y1: 1,
    x2: 33.2291,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89005"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdClogo);
export default __webpack_public_path__ + "static/media/CDClogo.12835738d6929025df1979aa80d45996.svg";
export { ForwardRef as ReactComponent };